import { render, staticRenderFns } from "./Ktp2.vue?vue&type=template&id=eb680b9c&"
import script from "./Ktp2.vue?vue&type=script&lang=js&"
export * from "./Ktp2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports